import { render, staticRenderFns } from "./DateItemsList.vue?vue&type=template&id=d20b0132&"
import script from "./DateItemsList.vue?vue&type=script&lang=js&"
export * from "./DateItemsList.vue?vue&type=script&lang=js&"
import style0 from "./DateItemsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports